import { Alert, AlertColor } from "@mui/material";
import { CustomContentProps, SnackbarContent } from "notistack";
import { forwardRef } from "react";

import CheckmarkIcon from "../icons/ui/CheckmarkIcon";
import ExclamationIcon from "../icons/ui/ExclamationIcon";

declare module "notistack" {
  interface VariantOverrides {
    customToast: {
      alertType: AlertColor;
    };
  }
}
interface IToastNotificationProps extends CustomContentProps {
  alertType: AlertColor;
}

const ToastNotification = forwardRef<HTMLDivElement, IToastNotificationProps>(
  ({ id, ...props }, ref) => {
    return (
      <SnackbarContent ref={ref} key={id}>
        <Alert
          ref={ref}
          severity={props.alertType}
          iconMapping={{
            success: <CheckmarkIcon />,
            error: <ExclamationIcon />,
          }}
          sx={{
            minWidth: 400,
            width: "unset",
            height: "unset",
            paddingX: 3,

            "& .MuiAlert-icon": {
              margin: "0 8px 0 0",
            },
          }}
        >
          {props.message}
        </Alert>
      </SnackbarContent>
    );
  },
);

export default ToastNotification;
